/*
 * Servierplatten-Abholgebühr an die Option "auf Servierplatten" koppeln.
 *
 * Das Element wird von snippets/servierplatten-fee-lock.liquid innerhalb von .js-contents
 * ausgegeben. Da Dawn den Warenkorb-Abschnitt per innerHTML neu rendert, laufen Scripts dort
 * kein zweites Mal – das Custom Element wird von selbst erneut aufgebaut und connectedCallback
 * greift nach jedem Warenkorb-Update wieder.
 */

if (!customElements.get('servierplatten-fee-lock')) {
  customElements.define(
    'servierplatten-fee-lock',
    class ServierplattenFeeLock extends HTMLElement {
      static ATTEMPT_KEY = 'servierplattenFeeFixAttempts';
      static MAX_ATTEMPTS = 3;

      connectedCallback() {
        this.required = this.dataset.required === 'true';
        this.feeIndex = parseInt(this.dataset.feeIndex, 10) || 0;
        this.feeQuantity = parseInt(this.dataset.feeQuantity, 10) || 0;

        if (!this.required) {
          // Ohne Servierplatten-Position ist die Gebühr freiwillig: Zeile wieder freigeben.
          this.unlockRow();
          this.resetAttempts();
          return;
        }

        if (this.feeIndex === 0) {
          this.repair(() => this.addFee());
          return;
        }

        if (this.feeQuantity > 1) {
          // Pauschale Gebühr – eine höhere Menge kann nur versehentlich entstanden sein.
          this.repair(() => this.changeFeeQuantity(1));
          return;
        }

        this.resetAttempts();
        this.lockRow();
      }

      get row() {
        if (!this.feeIndex) return null;
        return (
          document.getElementById(`CartItem-${this.feeIndex}`) ||
          document.getElementById(`CartDrawer-Item-${this.feeIndex}`)
        );
      }

      lockRow() {
        const row = this.row;
        if (!row) return;

        row.classList.add('cart-item--sp-locked');

        const input = row.querySelector('.quantity__input');
        if (input) {
          // readonly statt disabled: das Feld bleibt Teil der updates[]-Reihenfolge des Formulars.
          input.readOnly = true;
          input.tabIndex = -1;
        }

        row.querySelectorAll('.quantity__button').forEach((button) => {
          button.disabled = true;
        });

        const note = this.dataset.feeNote;
        const details = row.querySelector('.cart-item__details');
        if (note && details && !details.querySelector('.cart-item__sp-note')) {
          const element = document.createElement('small');
          element.className = 'cart-item__sp-note';
          element.textContent = note;
          details.appendChild(element);
        }
      }

      unlockRow() {
        const row = this.row;
        if (!row || !row.classList.contains('cart-item--sp-locked')) return;

        row.classList.remove('cart-item--sp-locked');

        const input = row.querySelector('.quantity__input');
        if (input) {
          input.readOnly = false;
          input.removeAttribute('tabindex');
        }

        row.querySelectorAll('.quantity__button').forEach((button) => {
          button.disabled = false;
        });

        const note = row.querySelector('.cart-item__sp-note');
        if (note) note.remove();
      }

      /*
       * Warenkorb-Korrekturen laufen über einen Zähler, damit ein dauerhaft fehlschlagender
       * Aufruf (z. B. Gebührenartikel nicht verfügbar) keine Reload-Schleife auslöst.
       */
      repair(action) {
        const attempts = this.attempts;
        if (attempts >= ServierplattenFeeLock.MAX_ATTEMPTS) return;

        this.attempts = attempts + 1;
        action()
          .then((ok) => {
            if (ok) window.location.reload();
          })
          .catch(() => {});
      }

      addFee() {
        return fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: this.dataset.feeVariantId, quantity: 1 }] }),
        }).then((response) => response.ok);
      }

      changeFeeQuantity(quantity) {
        return fetch(`${this.dataset.cartChangeUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: this.feeIndex, quantity: quantity }),
        }).then((response) => response.ok);
      }

      get attempts() {
        try {
          return parseInt(sessionStorage.getItem(ServierplattenFeeLock.ATTEMPT_KEY), 10) || 0;
        } catch (error) {
          return ServierplattenFeeLock.MAX_ATTEMPTS;
        }
      }

      set attempts(value) {
        try {
          sessionStorage.setItem(ServierplattenFeeLock.ATTEMPT_KEY, value);
        } catch (error) {
          // sessionStorage nicht verfügbar – dann bleibt es bei einem Versuch pro Seitenaufruf.
        }
      }

      resetAttempts() {
        try {
          sessionStorage.removeItem(ServierplattenFeeLock.ATTEMPT_KEY);
        } catch (error) {
          // ignorieren
        }
      }
    }
  );
}
